/*
 * @Author: DQL
 * @Date: 2020-03-09 17:00:31
 * @LastEditors: DQL
 * @LastEditTime: 2022-06-14 15:41:36
 * @Description: file content
 */
import axios from 'axios';
import config from '@/config';

const { commontCtx, authCtx } = config;

const { kqxtApi, hmfileApi, workflowCtx } = config.ctx;

// 登录认证
export const loginSys = (params) => { return axios.post(`${authCtx}/auth/security/login`, params).then(rsp => rsp); };

// 退出
export const logoutSys = () => { return axios.post(`${authCtx}/auth/security/logout`); };

// 获取身份信息
export const getSubject = () => { return axios.get(`${authCtx}/auth/security/info`); };

// 切换身份
export const changeSubject = (capacityCode) => { return axios.post(`${authCtx}/auth/security/switch?capacityCode=${capacityCode}`); };

// 当前用户菜单列表
export const getUserMenus = () => { return axios.get(`${commontCtx}/menu/currentUser/menu/tree`); };

// 获取系统枚举
export const getEnum = () => { return axios.get(`${commontCtx}/enums`); };

// 获取用户授权的的页面元素
export const getRoleElement = () => { return axios.get(`${commontCtx}/role/element`); };

// 密码强度校验
export const passwordCheck = (password) => { return axios.post(`${commontCtx}/admin/password/check`, password, { headers: { 'Content-Type': 'text/plain' } }); };

// 密码修改
export const changepwd = (fd) => { return axios.put(`${commontCtx}/person/changepwd`, fd); };

// 机构部门（无权限）
export const getDeptTree = (params) => { return axios.get(`${commontCtx}/dept/getDepts`, { params: params }); };

/* =======================================
   业务枚举服务start
*/
// 获取考勤系统业务枚举
export const getKqxtApiApiEnum = () => { return axios.get(`${kqxtApi}/enums`); };

/* 业务枚举服务end */
/* =======================================
   业务枚举start
*/

export const systemPreloadInfo = () => {
  return axios.all([getSubject(), getEnum(), getRoleElement(), getUserMenus(), getKqxtApiApiEnum()]);
};

// 图片验证码
export const kaptchaService = {
  // 获取验证码
  getCode: () => { return axios.get(`${commontCtx}/kaptcha`); },
  // 校验图片验证码
  codeValid: (code) => { return axios.post(`${commontCtx}/kaptcha/${code}`); }
};

// 注册
export const registerService = {
  // 注册
  register: (fd) => { return axios.post(`${commontCtx}/register`, fd).then(rsp => rsp); },

  // 激活账号
  activate: (params) => { return axios.get(`${commontCtx}/register`, { params: params }); },

  // 检查用户名是否重复
  validUserName: (fd) => { return axios.post(`${commontCtx}/register/isRepeatUsername`, fd); },

  // 检查账号是否重复
  validuserCode: (fd) => { return axios.post(`${commontCtx}/register/isRepeatUsercode`, fd); },

  // 检查邮箱是否重复
  validuserEmail: (params) => { return axios.get(`${commontCtx}/user/isRepeatEmail`, { params: params }); },

  // 检查密码强度
  validPassword: (fd) => { return axios.post(`${commontCtx}/register/passwordStrength`, fd); }
};

export const getJqlxList = () => { return axios.get(`${kqxtApi}/kqxt/common/jqlx`); };

export const getUserInfo = (params) => { return axios.get(`${kqxtApi}/kqxt/common/userinfo`, { params: params }); };

export const hmfileService = {
  // 查询
  query: (params) => { return axios.post(`${hmfileApi}/file/query`, params); },

  // 批量修改文件信息
  update: (params) => { return axios.post(`${hmfileApi}/file/batchUpdate`, params); },

  // 初始化下载
  initdownload: (fileId) => { return axios.get(`${hmfileApi}/file/initdownload/${fileId}`); },

  // 下载
  download: (filePath) => { return axios.get(`${hmfileApi}/file/download/${filePath}`, { responseType: 'blob' }); },

  // 文件删除
  delete: (fileId) => { return axios.delete(`${hmfileApi}/file/delete/${fileId}`); },

  // 批量删除文件
  batchDelete: (params) => { return axios.delete(`${hmfileApi}/file/batchDelete`, { data: params }); }
};

export const workflowService = {
  // 检测是否能进行流程撤回
  checkWithdraw: (taskId) => { return axios.get(`${workflowCtx}/wf/task/task/resume/flag/${taskId}`); },

  // 流程撤回
  workflowWithdraw: (fd) => { return axios.post(`${kqxtApi}/kqxt/workflow/back`, fd); },

  // 获取流程当前的任务信息
  getTask: (processInsId, taskId) => { return axios.get(`${workflowCtx}/wf/process/getTask/${processInsId}/${taskId}`); },

  // 检查工作流事项状态
  checkSubmit: (taskId) => { return axios.get(`${workflowCtx}/wf/task/status/${taskId}`); }

};
